import { render, staticRenderFns } from "./HotAndNewBusinesses.vue?vue&type=template&id=1fa8cce7&scoped=true&"
import script from "./HotAndNewBusinesses.vue?vue&type=script&lang=js&"
export * from "./HotAndNewBusinesses.vue?vue&type=script&lang=js&"
import style0 from "./HotAndNewBusinesses.vue?vue&type=style&index=0&id=1fa8cce7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8cce7",
  null
  
)

export default component.exports